import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
} from '@angular/core';

import { deepEqual } from 'fast-equals';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { TranslatePipe } from '@core/i18n-legacy';
import type { TooltipPosition } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  GroupComponent,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
  RtTooltip,
} from '@core/user-interface-legacy';

import { CvActionsService } from '../../services/cv-actions.service';

@Component({
  selector: 'rt-cv-actions',
  templateUrl: './cv-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    GroupComponent,
    ButtonComponent,
    IconComponent,
    IconButtonComponent,
    RtTooltip,
    OverlayOriginDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    TranslatePipe,
  ],
})
export class CvActionsComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly cvActions = inject(CvActionsService);

  public readonly tooltipPosition = input<TooltipPosition>('above');
  public readonly isAnonymized = input<boolean>(false);

  protected editable: boolean;
  protected isCvEmpty: boolean;
  protected loading: boolean;
  protected processing: boolean;
  protected originalUrl: string;
  protected url: string;
  protected anonymizationFailed: boolean;
  protected dropdownOpen: boolean = false;
  protected DropdownWidth = DropdownWidth;

  private ngOnDestroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.cvActions.actionsData$
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()), distinctUntilChanged(deepEqual))
      .subscribe(data => {
        this.editable = data.editable;
        this.isCvEmpty = data.isCvEmpty;
        this.loading = data.loading;
        this.originalUrl = data.originalUrl;
        this.url = data.url;
        this.processing = data.processing;
        this.anonymizationFailed = data.anonymizationFailed;
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public toggleDropdown(state: boolean | undefined = undefined): void {
    this.dropdownOpen = state === undefined ? !this.dropdownOpen : state;
    this.cdRef.detectChanges();
  }

  public uploadClick(): void {
    this.cvActions.inputClick$.next();
  }

  public deleteClick(): void {
    this.cvActions.deleteClick$.next();
  }

  public reparseClick(): void {
    this.cvActions.reparseClick$.next();
  }
}
